<template>
  <b-modal
    id="cms-create-banner"
    title="New Banner"
    no-close-on-backdrop
    @ok="onOk"
  >
    <ValidationObserver ref="cmsForm" v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          v-slot="{ errors }"
          name="title"
          :rules="{
            required: false,
          }"
        >
          <b-form-group label="Title">
            <b-form-input
              id="title"
              v-model="createBannerForm.title"
              :state="errors[0] ? false : null"
            ></b-form-input>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="image_src"
          :rules="{
            required: true,
          }"
        >
          <b-form-group label="Image">
            <CmsFileSelect
              :value="createBannerForm.imageSrc"
              :state="errors[0] ? false : null"
              @update="(value) => (createBannerForm.imageSrc = value || '')"
            />
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="position"
          :rules="{
            required: true,
          }"
        >
          <b-form-group label="Position">
            <b-form-input
              id="position"
              v-model="createBannerForm.position"
              :state="errors[0] ? false : null"
            ></b-form-input>
          </b-form-group>
        </ValidationProvider>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  components: {
    CmsFileSelect: () => import('../file-select.vue'),
  },
  data() {
    return {
      createBannerForm: {
        position: 0,
        title: '',
        imageSrc: '',
      },
    }
  },
  computed: {
    ...mapState({
      isCreatingSiteBanners: (state) => state.cms.isCreatingSiteBanners,
    }),
    ...mapGetters(['siteId']),
  },
  methods: {
    ...mapActions(['createCmsBanners']),
    async onOk(e) {
      e.preventDefault()
      const valid = await this.$refs.cmsForm.validate()
      if (valid) {
        this.onSubmit(() => this.$bvModal.hide('cms-create-banner'))
      }
    },
    async onSubmit(cb) {
      await this.createCmsBanners({
        siteId: this.siteId,
        banners: [this.createBannerForm],
      })

      cb()
    },
  },
}
</script>
